/*************************************************/
/* ACCORDION                                     */
/*************************************************/
import customEventsNames from './../customEventsNames';

export function accordion() {
    const accordionParentSelector = '.accordion';
    const accordionParentItem = ".accordion-item";
    const accordionItemSelector = '.accordion__item';
    const accordionItemToggleSelector = '.accordion__item-head';
    const accordionItemContentSelector = '.accordion__item-content';
    const accordionItemActiveClass = 'accordion__item--active';
    const accordionIdDataAttributeName = 'data-accordion-id';
    const accordionItemIdDataAttributeName = 'data-accordion-item-id';

    const getTargetedAccordion = (event) => {
        if (event != null) {
            return document.querySelector(
                `[${accordionIdDataAttributeName}="${event.detail.accordionId}"]`);
        }
    };

    const getTargetedAccordionItem = (event) => {
        if (event != null) {
            const targetedAccordion = getTargetedAccordion(event);
            if (targetedAccordion != null) {
                return targetedAccordion.querySelector(
                    `[${accordionItemIdDataAttributeName}="${event.detail.accordionItemId}"]`
                );
            }
        }
    };

    const setActiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            const accordionParentItemContent = document.querySelector(accordionParentItem);
            accordionItemContent.style.maxHeight = `${accordionItemContent.scrollHeight}px`;
            accordionItemContent.setAttribute('aria-hidden', false);
            accordionItem.classList.add(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', true);
            accordionParentItemContent.style.minHeight = `${accordionItemContent.scrollHeight + 200}px`;
        }
    };

    const setInactiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            const accordionParentItemContent = document.querySelector(accordionParentItem);
            accordionItemContent.style.maxHeight = "0px";
            accordionItemContent.setAttribute('aria-hidden', true);
            accordionItem.classList.remove(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', false);
            accordionParentItemContent.style.minHeight = "0px";
        }
    };

    const init = () => {
        const accordions = document.querySelectorAll(accordionParentSelector);
        if (accordions != null && accordions.length > 0) {
            accordions.forEach(accordion => {

                // Set minHeight on load based on the first item
                const firstAccordionItemContent = accordion.querySelector(accordionItemContentSelector);
                if (firstAccordionItemContent) {
                    const accordionParentItemContent = document.querySelector(accordionParentItem);
                    accordionParentItemContent.style.minHeight = `${firstAccordionItemContent.scrollHeight + 200}px`;
                }

                accordion.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (e.detail.deactivateAllItems) {
                        const deactivateAllItemsEvent = new CustomEvent(customEventsNames.accordionDeactivateAllItemsEventName, {
                            detail: {
                                accordionId: e.detail.accordionId
                            }
                        });
                        accordion.dispatchEvent(deactivateAllItemsEvent);
                    }

                    if (targetedAccordionItem != null) {
                        setActiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem != null) {
                        setInactiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateAllItemsEventName, e => {
                    const targetedAccordion = getTargetedAccordion(e);
                    if (targetedAccordion != null) {
                        targetedAccordion.querySelectorAll(accordionItemSelector).forEach(accordionItem => {
                            setInactiveStylesOnAccordionItem(accordionItem);
                        });
                    }
                });

                accordion.querySelectorAll(accordionItemToggleSelector).forEach(accordionItem => {
                    accordionItem.addEventListener('click', e => {
                        const clickedAccordionItem = e.target.closest(accordionItemSelector);
                        const itemId = clickedAccordionItem.dataset.accordionItemId;
                        const itemIndex = clickedAccordionItem.dataset.accordionItemIndex;
                        const accordionParent = e.target.closest(accordionParentSelector);
                        const accordionId = accordionParent.dataset.accordionId;

                        if (clickedAccordionItem.classList.contains(accordionItemActiveClass)) {
                            const deactiveAccordionItemEvent = new CustomEvent(customEventsNames.accordionDeactivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                }
                            });
                            accordionParent.dispatchEvent(deactiveAccordionItemEvent);
                        } else {
                            if (accordionParent.classList.contains('products-documentation__item-accordion') && clickedAccordionItem.classList.contains(accordionItemActiveClass)) {
                                const deactiveAccordionItemEvent = new CustomEvent(customEventsNames.accordionDeactivateItemEventName, {
                                    detail: {
                                        accordionId: accordionId,
                                        accordionItemId: itemId,
                                        deactivateAllItems: true
                                    }
                                });
                                accordionParent.dispatchEvent(deactiveAccordionItemEvent);
                            } else {
                                const activateAccordionItemEvent = new CustomEvent(customEventsNames.accordionActivateItemEventName, {
                                    detail: {
                                        accordionId: accordionId,
                                        accordionItemId: itemId,
                                        accordionItemIndex: itemIndex,
                                        deactivateAllItems: !accordionParent.classList.contains('products-documentation__item-accordion')
                                    }
                                });
                                const getContentHeight = accordionParent.offsetHeight;
                                if (getContentHeight > window.innerHeight) {

                                    setTimeout(function () {
                                        let top = e.target.getBoundingClientRect().top + document.documentElement.scrollTop;
                                        window.scroll({
                                            top: top - 300,
                                            behavior: 'smooth'
                                        });
                                    }, 300);
                                }
                                accordionParent.dispatchEvent(activateAccordionItemEvent);

                                const accordionSliderParent = accordionItem.closest('.accordion-slider');
                                if (accordionSliderParent) {
                                    accordionSliderParent.querySelector('.swiper').dispatchEvent(activateAccordionItemEvent)
                                }

                                const accordionImagesParent = accordionItem.closest('.accordion-images');
                                if (accordionImagesParent) {
                                    accordionImagesParent.querySelector('.accordion-images__images-container').dispatchEvent(activateAccordionItemEvent)
                                }
                            }
                        }
                    });
                });

                const accordionInitialized = new CustomEvent(customEventsNames.accordionInitialised, {});
                accordion.dispatchEvent(accordionInitialized);
            });
        }
    };

    if (window.location.hash) {
        const accordions = document.querySelectorAll('.accordion');
        if (accordions) {
            accordions.forEach(accordion => {
                accordion.addEventListener('accordionInitialized', e => {
                    const accordionItem = accordion.querySelector(window.location.hash);
                    if (accordionItem) {
                        const accordionToggle = accordionItem.closest('.accordion__item').querySelector('.accordion__item-head');
                        const accordionActive = accordionItem.closest('.accordion__item');
                        if (accordionToggle) {
                            if (!accordionActive.classList.contains('accordion__item--active')) {
                                accordionToggle.click();
                            }
                        }
                    }
                });
            });
        }
    }

    init();
}



// WEBPACK FOOTER //
// ./src/scripts/partials/accordion.js